import type { ShopperProducts } from '@/scapi';

export type BreadcrumbCategoryItem = {
    id: string;
    name: string;
};

type PathRecord = Required<ShopperProducts.schemas['Category']>['parentCategoryTree'][0];

/**
 * Builds the ordered category path for breadcrumbs from a SCAPI category.
 * Excludes the catalog root node, matching SFCC's parent walk that stops before root.
 */
export function getCategoryPathFromTree(category: ShopperProducts.schemas['Category']): BreadcrumbCategoryItem[] {
    const tree = category.parentCategoryTree?.filter((item) => item.id && item.id !== 'root') ?? [];

    if (tree.length > 0) {
        return tree.map((item: PathRecord) => ({
            id: item.id ?? '',
            name: item.name ?? item.id ?? '',
        }));
    }

    if (category.id && category.id !== 'root') {
        return [{ id: category.id, name: category.name ?? category.id }];
    }

    return [];
}

/**
 * Returns the single parent category shown on mobile.
 * PDP: leaf category (product's primary category). PLP: immediate parent category.
 */
export function getMobileParentCategoryItem(
    categoryPath: BreadcrumbCategoryItem[],
    isProductPage: boolean
): BreadcrumbCategoryItem | undefined {
    if (categoryPath.length === 0) {
        return undefined;
    }

    if (isProductPage) {
        return categoryPath.at(-1);
    }

    if (categoryPath.length < 2) {
        return undefined;
    }

    return categoryPath.at(-2);
}
